<p *ngIf="visible" class="no-access">{{ 'auth.signIn.noAccess' | translate }}</p>